module.exports = "/_next/static/images/herobanner-bg-3cc9c3dc194f77d858bfa09ca6c89009.webp";